import styled from "styled-components";
import { Calendar } from "react-vant";
import { useRef, useState, forwardRef, useImperativeHandle } from "react";
import { getDay, hideAccount } from "../../../utils/utils";
import { FormattedMessage, useIntl } from "react-intl";
import useWallet from "../../../hooks/Wallet/useWallet";
import ScrollList from "./ScrollList";
import moment from "moment";
import { getIncome, getWithdraw } from "../../../api";
const incomeTypeMap = {
  1: {
    name: "跑步收益",
    img: "image/icons/paobu.png",
  },
  2: { name: "体验卡上级收益", img: "image/icons/paobu.png" },
  3: { name: "直推奖励", img: "image/icons/zhidui.png" },
  4: { name: "社区分红", img: "image/icons/fenhong.png" },
};
export default forwardRef(Record2);
function Record2({}, ref) {
  useImperativeHandle(ref, () => {
    return {
      loadData: () => {
        clearData();
      },
    };
  });
  const intl = useIntl();
  const ref1 = useRef();
  const ref2 = useRef();
  const [active, setActive] = useState(1);
  // const { lang } = useCommon();
  const { myAccount } = useWallet();
  // const [list, setList] = useState([]);
  const now = Date.now();
  const endDate = getDay(now, 0);
  const startDate = getDay(now, -60);
  const rangeDateRef = useRef([new Date(startDate), new Date(endDate)]);

  const clearData = async () => {
    console.log("clearData");
    if (ref1.current) {
      ref1.current.clearData();
      ref1.current.refrushData();
    }
    if (ref2.current) {
      ref2.current.clearData();
      ref2.current.refrushData();
    }
  };
  const loadData = async (page) => {
    let list = [];
    if (active === 1) {
      list = await getIncome({
        addr: myAccount.account,
        begin: new Date(rangeDateRef.current[0]).getTime() / 1000,
        end:
          new Date(
            moment(rangeDateRef.current[1]).format("YYYY/MM/DD 23:59:59")
          ).getTime() / 1000,
        page: page,
      });
    } else {
      list = await getWithdraw({
        addr: myAccount.account,
        begin: new Date(rangeDateRef.current[0]).getTime() / 1000,
        end:
          new Date(
            moment(rangeDateRef.current[1]).format("YYYY/MM/DD 23:59:59")
          ).getTime() / 1000,
        page: page,
      });
    }

    console.log(list);
    // setList(list);
    return list;
  };

  return (
    <Wrapper>
      <Col>
        <div>
          <span
            className={active === 1 ? "t active" : "t"}
            onClick={() => setActive(1)}
          >
            <FormattedMessage id="收益记录" />
          </span>
          <span
            className={active === 2 ? "t active" : "t"}
            onClick={() => setActive(2)}
          >
            <FormattedMessage id="提币记录" />
          </span>
        </div>
        <Calendar
          type="range"
          minDate={new Date(2020, 0, 1)}
          maxDate={new Date()}
          value={rangeDateRef.current}
          onConfirm={(data) => {
            console.log("rangeDate", data);
            clearData();
            rangeDateRef.current = [data[0], data[1]];
          }}
        >
          {(val, actions) => (
            <Text onClick={() => actions.open()}>
              {val
                ? val.map((el) => moment(el).format("MM/DD")).join(" - ")
                : intl.formatMessage({
                    id: "pages.account.profit_select_date",
                    defaultMessage: "请选择日期",
                  })}
            </Text>
          )}
        </Calendar>
      </Col>
      {myAccount ? (
        <ListWrapper>
          {active === 1 ? (
            <ScrollList
              key={"1"}
              ref={ref1}
              getData={loadData}
              content={(e, key) => {
                return (
                  <div key={key} className="item">
                    <div className="left">
                      <img src={incomeTypeMap[e.income_type].img} alt="" />
                    </div>
                    <div className="content">
                      <div className="row" style={{ marginBottom: "1.4rem" }}>
                        <div className="hash">
                          <span>
                            <FormattedMessage
                              id={incomeTypeMap[e.income_type].name}
                            />
                          </span>
                          <span style={{ color: "#333", fontSize: "1.2rem" }}>
                            {" "}
                            ({e.nft_id})
                          </span>
                        </div>
                        <div className="value" style={{ color: "#f57627" }}>
                          +{e.income} RT
                        </div>
                      </div>
                      <div className="row">
                        <div>
                          {e.income_type === 1 ? (
                            <>
                              <span className="type">
                                <FormattedMessage id="步数" />{" "}
                              </span>
                              <span className="text">
                                <FormattedMessage
                                  id="components.nav.step"
                                  values={{ step: e.steps }}
                                />
                              </span>
                            </>
                          ) : e.income_type === 2 ? (
                            <>
                              <span className="type">
                                <FormattedMessage id="体验卡" />{" "}
                              </span>
                              <span className="text"></span>
                            </>
                          ) : e.income_type === 3 ? (
                            <>
                              <span className="type">
                                <FormattedMessage id="来源" />{" "}
                              </span>
                              <span className="text">
                                {hideAccount(e.original_address, 10, 9)}
                              </span>
                            </>
                          ) : e.income_type === 4 ? (
                            <>
                              <span className="type">
                                <FormattedMessage id="来源" />{" "}
                              </span>
                              <span className="text">LV {e.level}</span>
                            </>
                          ) : null}
                        </div>
                        <div className="text">
                          {moment(e.create_time).format("YYYY/MM/DD")}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }}
            ></ScrollList>
          ) : (
            <ScrollList
              key={"2"}
              ref={ref2}
              getData={loadData}
              content={(e, key) => {
                return (
                  <div key={key} className="item">
                    <div className="left">
                      <img src="image/rb4.png" alt="" />
                    </div>
                    <div className="content">
                      <div className="row" style={{ marginBottom: "1.4rem" }}>
                        <div className="hash">
                          <span>RT链上提币</span>
                        </div>
                        <div className="value">-{e.amount} RT</div>
                      </div>
                      <div className="row">
                        <div>
                          {e.result === 1 ? (
                            <>
                              <span className="text">提币成功</span>
                            </>
                          ) : e.result === 3 ? (
                            <>
                              <span className="text">提币失败</span>
                            </>
                          ) : (
                            <span className="text">提币中</span>
                          )}
                        </div>
                        <div className="text">
                          {moment(e.create_time).format("YYYY/MM/DD HH:mm")}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }}
            ></ScrollList>
          )}
        </ListWrapper>
      ) : null}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 2rem;
`;

const Col = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  .t {
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.8rem;
    color: #c4c4c4;
    margin-right: 1.6rem;
    &.active {
      color: #000;
    }
  }
`;

const Text = styled.div`
  background: #39ada4;
  border: 1px solid #ffffff;
  border-radius: 0.6rem;
  padding: 4px 0.7rem;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.4rem;
  color: #fff;
`;

const ListWrapper = styled.div`
  background-color: #fff;
  margin-top: 1.2rem;
  border-radius: 1rem;
  .item {
    display: flex;
    padding: 1.2rem 1.6rem;
    box-shadow: 0rem 0.05rem 0rem #e3e3e3;
    align-items: center;
    .left {
      img {
        width: 3.5rem;
        /* height: 3.0rem; */
      }
    }
    .content {
      flex: 1;
      padding-left: 1.2rem;
    }
    .row {
      display: flex;
      justify-content: space-between;
    }
    .hash {
      font-size: 1.5rem;
      line-height: 1.5rem;

      color: #000000;

      img {
        width: 1.2rem;
        height: 1.2rem;
      }
    }
    .value {
      font-weight: 500;
      font-size: 1.5rem;
      line-height: 1.4rem;

      color: #82d418;
    }

    .type {
      font-weight: 400;
      font-size: 1.2rem;
      line-height: 1.4rem;

      color: #969696;
    }
    .text {
      font-weight: 500;
      font-size: 1.3rem;
      line-height: 1.4rem;

      color: #000000;
    }
  }
`;
